import { postMedia } from '../api/postMedia';

export const setPostMedia = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postMedia(params);
            
            alert('Сохранено')
          
            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}